export default __webpack_public_path__ + "static/media/holmasto-logo.1bf2a432.svg";